import React from "react";
import { Button } from "antd";
import { ExportOutlined } from "@ant-design/icons";
import { useStore } from "../../../app/stores/store";
import { observer } from "mobx-react-lite";
import dayjs from "dayjs";
import * as XLSX from "xlsx";

const ExportSalaryExcel = () => {
  const { salaryStore } = useStore();
  const { salaryList } = salaryStore;

  const handleExport = () => {
    if (!salaryList || salaryList.length === 0) {
      console.error("No salary data available");
      return;
    }

    // Calculate total amount
    const totalAmount = salaryList.reduce(
      (sum, salary) => sum + (salary.amount || 0),
      0
    );

    // Create workbook
    const wb = XLSX.utils.book_new();

    // Prepare worksheet data with title
    const wsData = [
      // Title row (merged cells)
      ["Activations Advertising Payroll Salary", "", "", ""],
      // Empty row for spacing
      ["", "", "", ""],
      // Header row
      ["Date", "Employee Name", "Account No.", "Amount"],
      // Data rows
      ...salaryList.map((salary) => [
        dayjs(salary.uploadDate).format("M/D/YY"),
        salary.employeeName || "N/A",
        salary.employeeNumber ? `${salary.employeeNumber}` : "N/A",
        salary.amount ? salary.amount.toLocaleString() : "0",
      ]),
      // Total row
      ["", "", "", ""],
      ["", "", "", ""],
      ["", "", "Total Salary", totalAmount.toLocaleString()],
    ];

    // Create worksheet
    const ws = XLSX.utils.aoa_to_sheet(wsData);

    // Merge title cells (A1:D1)
    if (!ws["!merges"]) ws["!merges"] = [];
    ws["!merges"].push({ s: { r: 0, c: 0 }, e: { r: 0, c: 3 } });

    // Set column widths
    ws["!cols"] = [
      { width: 10 }, // Date
      { width: 30 }, // Name
      { width: 15 }, // Account No.
      { width: 12 }, // Amount
    ];

    // Format title row
    const titleCell = "A1";
    ws[titleCell].s = {
      font: { bold: true, size: 16 },
      alignment: { horizontal: "center" },
    };

    // Format header row
    const headerStyle = {
      font: { bold: true, color: { rgb: "000000" } },
      fill: { fgColor: { rgb: "F4C342" } },
      alignment: { horizontal: "center" },
    };

    // Format total row
    const totalRow = salaryList.length + 3; // +3 for title, empty row, and header
    const totalStyle = {
      font: { bold: true },
      fill: { fgColor: { rgb: "D9D9D9" } },
    };

    // Apply styles
    for (let C = 0; C <= 3; ++C) {
      const headerCell = XLSX.utils.encode_cell({ r: 2, c: C }); // Header is on row 3 (0-based)
      if (!ws[headerCell]) ws[headerCell] = {};
      ws[headerCell].s = headerStyle;

      // Style total row
      if (C === 2 || C === 3) {
        const totalCell = XLSX.utils.encode_cell({ r: totalRow, c: C });
        if (!ws[totalCell]) ws[totalCell] = {};
        ws[totalCell].s = totalStyle;
      }
    }

    // Add worksheet to workbook
    XLSX.utils.book_append_sheet(wb, ws, "Employee Salaries");

    // Generate Excel file
    const dateString = dayjs().format("YYYY-MM-DD");
    XLSX.writeFile(
      wb,
      `Activations_Advertising_Payroll_Salary_${dateString}.xlsx`
    );
  };

  return (
    <Button
      type="primary"
      style={{ backgroundColor: "#ff7201" }}
      icon={<ExportOutlined />}
      onClick={handleExport}
    >
      Export
    </Button>
  );
};

export default observer(ExportSalaryExcel);
